import storage from '@shared/js/storage';
import { EVENT } from '..';
import { playerBus } from '@videotools/js/events';

const handleProgress = (value) => {
	// only store position if it's greater than 1 to avoid race condition between stored position and player position
	if (storage.playerRestore && value > 1) {
		storage.playerRestore = {
			...storage.playerRestore,
			position: value,
		};
	}
};

const handlePlayerLoad = (eventId, isLive, autostartCouchMode) => {
	if (storage.playerRestore?.eventId === eventId && !isLive && !autostartCouchMode) {
		playerBus.seek(storage.playerRestore.position);
	}
};

const register = (bus) => {
	bus.subscribe(EVENT.PLAYER.ON.LOAD, handlePlayerLoad);
	bus.subscribe(EVENT.PLAYER.ON.PROGRESS, handleProgress);
};

export default register;
